import { useTranslation as useI18NextTranslation } from 'react-i18next';

import type { GetTranslationFunction } from 'ts/translation';

export const useTranslation = (namespace?: string) => {
  const { t, ...rest } = useI18NextTranslation(namespace, );

  return {
    ...rest,
    t: t as GetTranslationFunction,
  };
};
